module.exports = __webpack_public_path__ + "assets/retina_PerpBisectorDetailed.518d520735250521d2e6142a9913355e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_PerpBisectorDetailed.png
// module id = 705
// module chunks = 0